// import $math from './toolClass/math.js'
// import publicFn from './toolClass/publicFn.js'
import * as Echarts from 'echarts';
let classComponent = require.context('@/util/toolClass', true, /\.js$/)
let httpComponent = require.context('@/util/request', true, /\.js$/)
let serveComponent = require.context('@/serve', true, /\.js$/)
let [utilMaps] = [{}];
[classComponent, httpComponent,serveComponent].forEach(item => {
    item.keys().forEach(srcName => {
        let curComponent = item(srcName);
        let [fileName] = srcName.match(/\w+/i);
        // let [fileName] = srcName.match(/(?<=\/).+?(?=.js)/g);
        utilMaps[fileName] = curComponent;
    })
})
export default {
    install(Vue) {
        Object.keys(utilMaps).forEach(key => {
            Vue.prototype[`$` + key] = utilMaps[key].default || utilMaps[key]
        })

        // Vue.prototype.getNameByCode = function (list,value,c_key='value',n_key='label') {
        //     return list.filter(item=>item[c_key] == value)[0][n_key]
        // }
        Vue.prototype.$Echarts = Echarts;//数字运算
        // Vue.prototype.$echarts = $math;//数字运算
    }
}


// WEBPACK FOOTER //
// ./src/util/install.js